import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { FormSettingsFieldsViewTopBar } from "./TopBar"

export const formSettingsFieldsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: FormSettingsFieldsViewTopBar,
}
